import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillsAssessmentSection = ({ skills, handleSkillRating }) => {
  const proficiencyLevels = [
    { value: 1, label: 'Beginner' },
    { value: 2, label: 'Intermediate' },
    { value: 3, label: 'Advanced' },
    { value: 4, label: 'Expert' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Target" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Skills Assessment</h3>
          <p className="text-sm text-muted-foreground">Rate your proficiency in required skills</p>
        </div>
      </div>
      <div className="space-y-6">
        {skills?.map((skill) => (
          <div key={skill?.id} className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Icon name="Code" size={16} className="text-primary" />
                <span className="text-sm font-medium text-foreground">{skill?.name}</span>
                {skill?.required && (
                  <span className="px-2 py-0.5 bg-error/10 text-error text-xs font-medium rounded">
                    Required
                  </span>
                )}
              </div>
              <span className="text-sm font-medium text-primary">
                {proficiencyLevels?.find(level => level?.value === skill?.rating)?.label || 'Not rated'}
              </span>
            </div>

            <div className="flex items-center gap-2">
              {proficiencyLevels?.map((level) => (
                <button
                  key={level?.value}
                  onClick={() => handleSkillRating(skill?.id, level?.value)}
                  className={`flex-1 py-3 px-4 rounded-lg text-sm font-medium transition-smooth ${
                    skill?.rating === level?.value
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  {level?.label}
                </button>
              ))}
            </div>

            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all duration-300"
                style={{ width: `${(skill?.rating / 4) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsAssessmentSection;